// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

Vue.config.productionTip = false

/* eslint-disable no-new */

if(!window.config){
	window.config = {
		align: "center",
		// video: "https://g.alicdn.com/acca/resource/luban/video/2500-1100.mp4",
		title: "https://gw.alicdn.com/bao/uploaded/TB1o.rKmntYBeNjy1XdXXXXyVXa-390-60.png",
		style: "inline",
		platforms: [{
			imgSrc: "http://gw.alicdn.com/mt/TB1ooddXr1YBuNjSszeXXablFXa-72-56.png",
			color: "rgba(232, 58, 39, 1)",
			name: "淘宝账号",
			inner: true,
			url: "https://login.taobao.com/member/login.jhtml?redirectURL=https%3A%2F%2Fwww.aliyun.com%2F"
		}, {
			imgSrc: "http://gw.alicdn.com/mt/TB1SGi2XDJYBeNjy1zeXXahzVXa-78-48.png",
			color: "rgba(55, 61, 65, 1)",
			name: "阿里云账号",
			url: "https://account.aliyun.com/login/login.htm?oauth_callback=https%3A%2F%2Fwww.aliyun.com%2F"
		}, {
			imgSrc: "http://gw.alicdn.com/mt/TB1_gBdXA9WBuNjSspeXXaz5VXa-64-56.png",
			color: "rgba(243, 115, 39, 1)",
			name: "域账号",
			hint: "仅限阿里员工",
			url: "https://login.alibaba-inc.com/ssoLogin.htm?APP_Name=alineiwai&BACK_URL=https%3A%2F%2Fwork.alibaba-inc.com%2F"
		}],
		otherLogin:[{
			name: "阿里云RAM子账号登录",
			inner: true,
			url: "http://signin.aliyun.test/login.htm?callback=https%3A%2F%2Fluban.aliyun.test%2Flogin%2Fcallback%2Faliyun"
		}]
	}
}

new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js